import { title } from "./style";
import { CameraSettings } from "components/CameraSettings";
import { InputLevel } from "components/InputLevel";
import { MicSettings } from "components/MicSettings";
import { Spacer } from "components/Spacer";
import { Subtitle02 } from "components/Typography/Subtitle02";
import { MicVideoSettingsProps } from "types";
import { Color } from "utils/variables";
import { isSmartPhone } from "utils/checkDevice";

const isSp = isSmartPhone();

export const MicCameraSettings = ({
  audioDevices,
  videoDevices,
  onChangeAudioDevice,
  onChangeVideoDevice,
}: MicVideoSettingsProps) => {
  return (
    <>
      <div className={title}>
        <Subtitle02 color={Color.WarmGrey}>マイク/カメラの設定</Subtitle02>
      </div>
      <Spacer size={20} />
      <MicSettings audioDevices={audioDevices} onChange={onChangeAudioDevice} />
      <Spacer size={20} />
      <InputLevel />
      <Spacer size={20} />
      {!isSp && (
        <CameraSettings
          videoDevices={videoDevices}
          onChange={onChangeVideoDevice}
        />
      )}
    </>
  );
};
